import { render } from "./UserMessage.vue?vue&type=template&id=75f15dbc&scoped=true"
import script from "./UserMessage.vue?vue&type=script&lang=js"
export * from "./UserMessage.vue?vue&type=script&lang=js"

import "./UserMessage.vue?vue&type=style&index=0&id=75f15dbc&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f15dbc"]])

export default __exports__